<style>
@import "tailwindcss";
@import "@nuxt/ui";

@theme {
  --font-sans: 'Public Sans', sans-serif;
  --breakpoint-3xl: 1920px;

  --color-primary: var(--ui-color-primary-500);
  --color-secondary: var(--ui-color-secondary-500);
  --color-success: var(--ui-color-success-500);
  --color-info: var(--ui-color-info-500);
  --color-warning: var(--ui-color-warning-500);
  --color-error: var(--ui-color-error-500);
}

/* Font smoothing for crisp text rendering */
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Custom selection color - indigo theme */
::selection {
  background-color: var(--ui-color-primary-500);
  color: white;
}
</style>

<script setup lang="ts">
const { locale, locales } = useI18n()
const colorMode = useColorMode()
const color = computed(() => colorMode.value === 'dark' ? '#111827' : 'white')
// Detect if the app should run in embed layout
const route = useRoute()
const isIframe = ref(false)

if (process.client) {
  const checkIframe = () => {
    try {
      isIframe.value = window.self !== window.top
    } catch (e) {
      // Access to window.top can throw if cross-origin; assume embedded
      isIframe.value = true
    }
  }
  onMounted(checkIframe)
}

const queryForcesEmbed = computed(() => {
  const q = route.query
  const layoutQuery = Array.isArray(q.layout) ? q.layout[0] : q.layout
  const embedQuery = Array.isArray(q.embed) ? q.embed[0] : q.embed
  const layoutIsEmbed = typeof layoutQuery === 'string' && layoutQuery.toLowerCase() === 'embed'
  const embedFlag = typeof embedQuery === 'string' && ['1', 'true', 'yes'].includes(embedQuery.toLowerCase())
  return layoutIsEmbed || embedFlag
})

const isEmbed = computed(() => queryForcesEmbed.value || isIframe.value)

useHead({
  title: 'KeyReply',
  meta: [
    { charset: 'utf-8' },
    { name: 'description', content: 'KeyReply - AI-powered chatbot platform' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: 'en',
    'data-embed': computed(() => (isEmbed.value ? 'true' : 'false'))
  }
})
</script>

<template>
  <UApp :locale="locales[locale as string]">
    <NuxtLoadingIndicator />
    <NuxtLayout :name="isEmbed ? 'embed' : 'default'">
      <NuxtPage />
    </NuxtLayout>
    <ConfirmDialog />
  </UApp>
</template>
